import { BillingEdit } from "@/modules/billing/billingAccount/BillingCreate.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/billing/account/$id/edit")({
    component: Component,
});

function Component() {
    const { id } = Route.useParams();
    const baId = Number(id);
    return <BillingEdit key={baId} baId={baId} />;
}
